module.exports = __webpack_public_path__ + "static/media/Icon_Demo.58983932.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_Demo.svg
// module id = 2315
// module chunks = 0